<router-outlet></router-outlet>
<footer class="page-footer" style="background-color: #373838;">
    <div class="container">
        <div class="row">
            <div class="col s12">
                <h5 class="white-text">Yeminus S.A.S
                </h5>
                <p class="grey-text text-lighten-4"></p>
            </div>
        </div>
    </div>
    <div class="footer-copyright">
        <div class="container">
            Made by <a class="orange-text text-lighten-3" href="http://yeminus.com">Yeminus SAS</a>
            <div class="pull-right">
                <yeminus-version></yeminus-version>
            </div>
        </div>
    </div>
</footer>